import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const PRIVACY_CONTENT = <div className="space-y-4 text-left" data-id="element-67">
    <h3 className="text-xl font-bold text-matrix-primary mb-4" data-id="element-68">
      Política de Privacidad
    </h3>
    <p data-id="element-69">
      En Mente Maestra, respetamos su privacidad y estamos comprometidos a
      protegerla. Esta política explica cómo manejamos su información.
    </p>

    <h4 className="text-lg font-bold text-matrix-text mt-4" data-id="element-70">
      1. Recopilación de Información
    </h4>
    <p data-id="element-71">
      Solo recopilamos la información necesaria para procesar su compra y
      entregarle los productos digitales (audiolibro, ebook y workbook). Esto
      incluye su nombre y dirección de correo electrónico. No almacenamos
      información de tarjetas de crédito; los pagos son procesados por
      proveedores seguros externos.
    </p>

    <h4 className="text-lg font-bold text-matrix-text mt-4" data-id="element-72">
      2. Uso de la Información
    </h4>
    <p data-id="element-73">
      Utilizamos su correo electrónico para enviarle los enlaces de descarga de
      sus productos y, ocasionalmente, actualizaciones relevantes sobre Mente
      Maestra. No vendemos ni compartimos sus datos con terceros para fines
      comerciales.
    </p>

    <h4 className="text-lg font-bold text-matrix-text mt-4" data-id="element-74">3. Cookies</h4>
    <p data-id="element-75">
      Utilizamos cookies esenciales para el funcionamiento del carrito de
      compras y el proceso de pago. También podemos usar herramientas de
      análisis anónimas para mejorar la experiencia del sitio.
    </p>

    <h4 className="text-lg font-bold text-matrix-text mt-4" data-id="element-76">4. Seguridad</h4>
    <p data-id="element-77">
      Tomamos medidas razonables para proteger su información personal contra
      pérdida, robo y uso no autorizado.
    </p>
  </div>;
const TERMS_CONTENT = <div className="space-y-4 text-left" data-id="element-78">
    <h3 className="text-xl font-bold text-matrix-primary mb-4" data-id="element-79">
      Términos y Condiciones
    </h3>
    <p data-id="element-80">
      Al comprar y descargar los productos de Mente Maestra, usted acepta los
      siguientes términos.
    </p>

    <h4 className="text-lg font-bold text-matrix-text mt-4" data-id="element-81">1. Uso Personal</h4>
    <p data-id="element-82">
      Los productos adquiridos (audiolibro, ebook, workbook) son para su uso
      personal y exclusivo. Está estrictamente prohibida su distribución,
      reventa, copia o publicación en cualquier medio sin autorización expresa.
    </p>

    <h4 className="text-lg font-bold text-matrix-text mt-4" data-id="element-83">
      2. Propiedad Intelectual
    </h4>
    <p data-id="element-84">
      Todo el contenido, diseño y material de Mente Maestra están protegidos por
      derechos de autor y propiedad intelectual.
    </p>

    <h4 className="text-lg font-bold text-matrix-text mt-4" data-id="element-85">
      3. Política de Reembolso
    </h4>
    <p data-id="element-86">
      Debido a la naturaleza digital de nuestros productos, todas las ventas son
      finales una vez que se ha enviado el enlace de descarga. Si tiene
      problemas técnicos con la descarga, le asistiremos para resolverlos.
    </p>

    <h4 className="text-lg font-bold text-matrix-text mt-4" data-id="element-87">
      4. Descargo de Responsabilidad
    </h4>
    <p data-id="element-88">
      Mente Maestra es una herramienta de desarrollo personal. No garantizamos
      resultados específicos, ya que estos dependen del compromiso y la
      implementación individual de cada usuario. Este producto no sustituye el
      consejo médico o psicológico profesional.
    </p>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="py-12 text-center text-matrix-muted text-sm border-t border-matrix-dim-orange bg-matrix-bg relative z-10" data-id="element-89">
        <div className="max-w-4xl mx-auto px-4" data-id="element-90">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-4" data-id="element-91">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-matrix-primary transition-colors underline decoration-matrix-primary/30 underline-offset-4 hover:decoration-matrix-primary" data-id="element-92">
              Política de Privacidad
            </button>
            <span className="hidden md:inline text-matrix-dim-orange" data-id="element-93">•</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-matrix-primary transition-colors underline decoration-matrix-primary/30 underline-offset-4 hover:decoration-matrix-primary" data-id="element-94">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-matrix-muted/60" data-id="element-95">
            © {new Date().getFullYear()} Mente Maestra. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-96">
        {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-97">
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setActiveModal(null)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-98" />

            {/* Modal Card */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative bg-matrix-surface border border-matrix-primary/30 rounded-lg w-full max-w-2xl max-h-[80vh] flex flex-col shadow-[0_0_50px_rgba(0,255,65,0.15)]" data-id="element-99">
              {/* Header with Close Button */}
              <div className="flex justify-end p-4 border-b border-matrix-primary/10 sticky top-0 bg-matrix-surface/95 backdrop-blur z-10 rounded-t-lg" data-id="element-100">
                <button onClick={() => setActiveModal(null)} className="p-2 text-matrix-muted hover:text-matrix-primary hover:bg-matrix-primary/10 rounded-full transition-colors" aria-label="Cerrar" data-id="element-101">
                  <X className="w-5 h-5" data-id="element-102" />
                </button>
              </div>

              {/* Scrollable Content */}
              <div className="p-6 md:p-8 overflow-y-auto custom-scrollbar text-matrix-muted leading-relaxed" data-id="element-103">
                {activeModal === 'privacy' ? PRIVACY_CONTENT : TERMS_CONTENT}
              </div>

              {/* Footer gradient fade */}
              <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-matrix-surface to-transparent pointer-events-none rounded-b-lg" data-id="element-104" />
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}